import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Request } from '../../interfaces/request';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';
import { RequestState } from 'src/app/models/enums/requestState';

@Component({
  selector: 'app-widget-requests',
  templateUrl: './widget-requests.component.html',
  styleUrls: ['./widget-requests.component.scss']
})
export class WidgetRequestsComponent implements OnInit {
  @Input({ required: true }) widgetData!: any;
  @Output() widgetLoaded: EventEmitter<any> = new EventEmitter<any>();
  mockRequest: Request = {
    date: "",
    title: ""
  }
  requests: Request[] = [];
  displayedColumns: string[] = ['text', 'state', 'date'];
  loading: boolean = false;
  RequestState = RequestState;
  isServerError: boolean = false;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.requests = Array.from({ length: this.widgetData.maxDisplayItems }, () => (this.mockRequest));
    this.getData();
  }

  getData() {
    this.loading = true;
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetRequestsForWidget';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      maxDisplayItems: this.widgetData.maxDisplayItems
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.requests = responseData;
        this.widgetLoaded.emit({ exists: true, count: this.requests.length, title: this.widgetData.title, loading: false });
        this.loading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.loading = false;
        this.isServerError = true;
      }
    });
  }
}
